import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
		marginBottom: theme.spacing.small,

		[getFromBreakpoint('lg')]: {
			position: 'sticky',
			alignSelf: 'start',
			top: `calc(${theme.navbar.height} + ${theme.spacing.small})`,
		},
	},
}));
